import { Vector, LineSettings, LinePinComponent } from '../../models';
import { newLine, newSize, newVector } from '../geometry';
import { defaultOrder } from '../order';
import { randomId } from '../random-id';
import { initialPinComponentPosition } from './pin-component';

type NewLinePinComponentProps = {
  start?: Vector;
  end?: Vector;
  settings?: Partial<LineSettings>;
  order?: string;
};

const linePinComponentDefaultSize = newSize(75, 0);

export function newLinePinComponent({
  start = initialPinComponentPosition,
  end = newVector(start.x + linePinComponentDefaultSize.width, start.y + linePinComponentDefaultSize.height),
  settings,
  order = defaultOrder,
}: NewLinePinComponentProps): LinePinComponent {
  return {
    type: 'LINE',
    id: randomId(),
    settings: {
      tailMarker: 'NONE',
      headMarker: 'NONE',
      ...settings,
    },
    layout: newLine(start, end),
    order,
  };
}
